<template>
  <div id="app">
    <header-section :api="api"/>
    <welcome-section :api="api"/>
    <who-we-are-section :api="api"/>
    <team-section :api="api.advogados"/>
    <partners-section :api="api"/>
    <what-we-do-section :api="api"/>
    <what-we-think-section :api="api"/>
    <contact-section :api="api"/>
    <copyright-section :api="api"/>
  </div>
</template>

<script>
import HeaderSection from './components/HeaderSection'
import WelcomeSection from './components/WelcomeSection'
import WhoWeAreSection from './components/WhoWeAreSection'
import TeamSection from './components/TeamSection'
import PartnersSection from './components/PartnersSection'
import WhatWeDoSection from './components/WhatWeDoSection'
import WhatWeThinkSection from './components/WhatWeThinkSection'
import ContactSection from './components/ContactSection'
import CopyrightSection from './components/CopyrightSection'

export default {
  name: 'App',
  components: {
    HeaderSection,
    WelcomeSection,
    WhoWeAreSection,
    TeamSection,
    PartnersSection,
    WhatWeDoSection,
    WhatWeThinkSection,
    ContactSection,
    CopyrightSection
  },
  data() {
    return {
      msg: 'Oi',
      api: []
    }
  },
  created() {
    this.$http.get('http://allegretti.adv.br/admin/wp-json/friday-cms/v1/conteudo').then(function(data){
			let content = data.body['editar-conteudo'][0];

      this.api = content;

      document.getElementById("loader").classList.remove("active");
    });
    
  },
}
</script>

<style lang="stylus">
html, body
  padding 0 !important
  margin 0 !important
  font-family 'Open Sans'
.loader-container
	background black
	width 100%
	height 100vh
	position fixed
	top 0
	left 0
	bottom 0
	right 0
	opacity 0
	z-index 10000
	visibility hidden
	transition .2s all ease
	display none
	&.active
		opacity 1
		visibility visible
		display block
.loader 
	border 4px solid #111
	border-top 4px solid #ddd
	border-radius 50%
	width 30px
	height 30px
	position absolute
	left 50%
	top 50%
	margin -15px 0 0 -15px
	animation spin 2s linear infinite
@keyframes spin 
		0%
			transform rotate(0deg)
		100%
			transform rotate(360deg)

.title
  font-family 'Playfair Display', serif
  font-size 72px
  font-weight 300
  text-transform uppercase
  text-align center
  &.lil
    font-size 36px
    font-weight bold
  &.name
    font-size 21px
    text-transform uppercase
    text-align left
    font-weight bold
a
  text-decoration none
  color black
p
  font-size 18px
  font-weight 300
.text
  line-height 1.8
.separator
  display block
  height 2px
  width 110px
  position relative
  left -40px
  background #7C8A8F
  &.rotate
    transform rotate(90deg)
ul
  list-style none
  text-align left
  padding-inline-start 0 
.wrapper
  width 80%
  max-width 1280px
  margin 0 auto
@media (max-width 640px)
  .title
    font-size 42px
    text-align center
  p
    font-size 14px
</style>



// WEBPACK FOOTER //
// src/App.vue